module.exports = __webpack_public_path__ + "img/wallet_mb_02.652cc30c.png";